import { render, staticRenderFns } from "./customizeMyDesignDrawer.vue?vue&type=template&id=0570c5e2&scoped=true"
import script from "./customizeMyDesignDrawer.vue?vue&type=script&lang=js"
export * from "./customizeMyDesignDrawer.vue?vue&type=script&lang=js"
import style0 from "./customizeMyDesignDrawer.vue?vue&type=style&index=0&id=0570c5e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570c5e2",
  null
  
)

export default component.exports